import axios from 'axios';
import BaseAPI from './base-api';
import LoanApplicationHistory_ from './models/LoanApplicationHistory';
import QDApplicationModel_ from './models/QDApplicationModel';
import { ValueConstants } from '../utils/enum';

export default class LoanApplicationsAPI extends BaseAPI {
  static async getEvaluatedQDModels(customerType) {
    const reduceStringContent = (value, maxValue) => ((value || '').length <= maxValue ? value : `${value.substring(0, maxValue)}...`);

    const qdEvaluetedModelsResult = await BaseAPI.promiseWrapper<QDApplicationModel_[]>(axios({
      url: `${window.feHost}/api/LoanApplications/EvaluateQDModels?customerType=${customerType}`,
      headers: this.getRequestHeaders(),
    }));

    const editResult = qdEvaluetedModelsResult;
    editResult.result = (qdEvaluetedModelsResult.result || [])
      .sort((a, b) => a?.displayOrder - b?.displayOrder)
      .map(it => {
        const item = it;
        if (Object.prototype.hasOwnProperty.call(item, 'customerPortalImage')) {
          item.customerPortalImage = item.customerPortalImage ? `data:image/png;base64,${item.customerPortalImage}` : '';
        }
        if (Object.prototype.hasOwnProperty.call(item, 'customerPortalDescription')) {
          item.customerPortalDescription = reduceStringContent(item.customerPortalDescription, ValueConstants.MaxQDModelDescriptionLength);
        }
        if (Object.prototype.hasOwnProperty.call(item, 'customerPortalTitle')) {
          item.customerPortalTitle = reduceStringContent(item.customerPortalTitle, ValueConstants.MaxQDModelTitleLength);
        }
        return item;
      });

    return editResult;
  }

  static getLoanApplicationsHistory() {
    return BaseAPI.promiseWrapper<LoanApplicationHistory_[]>(axios({
      url: `${window.feHost}/api/LoanApplications/InquireQDHistory`,
      headers: this.getRequestHeaders(),
    }));
  }
}
